import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ProduktvalModule } from "../produktval/produktval.module";
import { ProduktionsmallAccordionBodyComponent } from "./accordion/produktionsmall-accordion-body/produktionsmall-accordion-body.component";
import { ProduktionsmallAccordionComponent } from "./accordion/produktionsmall-accordion/produktionsmall-accordion.component";
import { ProduktionsmallarComponent } from "./produktionsmallar.component";
import { MinaProduktionsmallarDialogService } from "./services/mina-produktionsmallar-dialog.service";
import { ProduktionsmallarService } from "./services/produktionsmallar.service";

@NgModule({
    exports: [ProduktionsmallarComponent],
    imports: [
        RaskCommonModule,
        ProduktvalModule,
        ProduktionsmallarComponent,
        ProduktionsmallAccordionComponent,
        ProduktionsmallAccordionBodyComponent
    ],
    providers: [
        ProduktionsmallarService,
        MinaProduktionsmallarDialogService
    ]
})

export class ProduktionsmallarModule { }
